import React from 'react';
import PropTypes from 'prop-types';
import { Form, Radio } from 'antd';
import { Fade } from 'react-awesome-reveal';

const InvestorProfileQuestion = ({ question, onAnswer: handleAnswer }) => {
  const radioStyle = {
    display: 'block',
  };

  const getAnswerSelectHandler = (answer) => () => {
    setTimeout(() => handleAnswer(answer), 200);
  };

  return (
    <Form.Item>
      <p>
        <b>Pregunta {question.order}:</b>
      </p>
      <Fade>
        <Form.Item name={`answer-${question.order}`} label={question.title}>
          <Radio.Group>
            {question.answers.map((answer) => (
              <Radio
                value={answer}
                style={radioStyle}
                key={answer.order}
                onClick={getAnswerSelectHandler(answer)}
              >
                {answer.description}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      </Fade>
    </Form.Item>
  );
};

InvestorProfileQuestion.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    order: PropTypes.number.isRequired,
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string.isRequired,
        order: PropTypes.number.isRequired,
        score: PropTypes.number.isRequired,
      })
    ),
  }).isRequired,
  onAnswer: PropTypes.func.isRequired,
};

export default InvestorProfileQuestion;
